<template>
	<div>
		<!-- 受众 -->
		<el-col class="shouzhong">
			<client-module class="clientmodule" moduletitle="受众报告" v-loading="loadingAudience">
				<div class="view-details" slot="event" @click="onviewport">查看详情</div>
				<div class="chart-panel">
					<div class="chart-item">
						<div class="bar">
							<fb-gender-series :condition="condition_gender"></fb-gender-series>
						</div>
						<div class="pie">
							<fb-contry-bar :condition="condition_contry"></fb-contry-bar>
						</div>
					</div>
				</div>
			</client-module>
		</el-col>
		<!-- 广告系列 -->
		<el-col class="charts-box">
			<div class="chart-tabs">
				<div
					v-for="item in toolbar"
					:key="item.flag"
					:class="activeClass == item.flag ? 'active' : ''"
					@click="handleClick(item.flag, item.label)"
				>
					{{ item.label }}
				</div>
			</div>
			<div class="chart-panel">
				<div class="hint-title">
					{{ tishiName }}
					<el-tooltip class="item" effect="dark" :content="interpretation" placement="bottom-start">
						<ig-icon name="tishi"></ig-icon>
					</el-tooltip>
				</div>
				<div class="chart-item">
					<div class="bar">
						<fb-series
							:activeClass="activeClass"
							:condition="condition"
							@googlereports="setselectNum"
						></fb-series>
					</div>
					<div class="pie">
						<fb-series-pie
							:activeClass="activeClass"
							:condition="conditionPie"
							@googlereportspie="setselectNumPie"
						></fb-series-pie>
					</div>
				</div>
			</div>
		</el-col>

		<!-- dataList -->
		<el-col class="google-list">
			<client-module class="clientmodule" :moduletitle="activeName + '展示次数TOP50详情'">
				<el-button type="primary" slot="event" size="mini" @click="googlederive">下载</el-button>
				<data-list
					:table-style="{ name: 'webclient' }"
					:data="dataList"
					:columns="columns"
					:loading="loading"
				></data-list>
			</client-module>
		</el-col>
	</div>
</template>

<script>
import fbSeries from '@/components/client/clientCharts/fb-series';
import fbSeriesPie from '@/components/client/clientCharts/fb-series-pie';
import clientModule from '@/components/client/clientModule/clientModule';
import fbContryBar from '@/components/client/clientCharts/fb-contry-bar.vue';
import fbGenderSeries from '@/components/client/clientCharts/fb-gender-series.vue';
export default {
	components: {
		fbSeries,
		fbSeriesPie,
		clientModule,
		fbContryBar,
		fbGenderSeries,
	},
	props: {
		toolbar: Array,
		tishiName: String,
		interpretation: String,
		activeClass: String,
		condition: Object,
		conditionPie: Object,
		conditionAudience: Object,
		dataList: Array,
		activeName: String,
		column: Array,
		loading: Boolean,
		loadingAudience: Boolean,
	},

	data() {
		return {
			columns: [],
			condition_gender: null,
			condition_contry: null,
		};
	},
	watch: {
		column: {
			immediate: true,
			deep: true,
			handler(val) {
				this.columns = _.cloneDeep(val);
			},
		},
		conditionAudience: {
			immediate: true,
			deep: true,
			handler(val) {
				if (val && val.genderAge) {
					this.condition_gender = val.genderAge;
					this.condition_contry = val;
				} else {
					this.condition_gender = {};
					this.condition_contry = {};
				}
			},
		},
	},
	methods: {
		handleClick(flag, label) {
			this.$emit('handleClick', flag, label);
		},
		setselectNum(val) {
			this.$emit('setselectNum', val);
		},
		setselectNumPie(val) {
			this.$emit('setselectNumPie', val);
		},
		// 下载数据
		googlederive() {
			this.$emit('googlederive');
		},
		onviewport() {
			this.$router.push({
				name: 'facebookDetails',
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.charts-box {
  padding: 0 0 20px;
  background: #fff;
  box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
  border-radius: 4px;
  margin-bottom: 10px;

  .chart-tabs {
    width: 100%;
    height: 60px;
    line-height: 60px;
    padding: 0 14px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    justify-content: flex-start;

    div {
      height: 100%;
      padding: 0 10px;
      margin-right: 50px;
      font-size: 16px;
      font-weight: bold;
      color: #333;
      border-bottom: 2px solid transparent;
      user-select: none;
      cursor: pointer;
    }

    .active {
      color: #1890ff;
      border-bottom: 2px solid #1890ff;
    }
  }

  .chart-panel {
    padding: 0 20px;

    .hint-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      line-height: 22px;
      margin-bottom: 10px;
      padding: 0 14px;

      i {
        font-size: 12px;
        color: #999;
        margin-left: 5px;
      }
    }
  }
}

.chart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .bar {
    width: 50%;
    box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
    border-radius: 4px;
    margin-right: 10px;
  }

  .pie {
    width: 50%;
    box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
    border-radius: 4px;
    margin-left: 10px;
  }
}

.google-list {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
  border-radius: 4px;

  .clientmodule {
    .data-list {
      margin: 20px 27px 0;
    }
  }
}

.shouzhong {
  @extend .charts-box;

  .chart-panel {
    padding-top: 20px;
  }
}
</style>
